(ns frontend.view.settings2.surveys.timeseries.model
  (:require [common.localization :as loc]
            [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
            [common.schema.entities.survey.timeseries :as timeseries]
            [common.util :as cu]
            [potpuri.core :as potpuri]
            [ui.util :as uu]))

(def tab-historical-data
  {:tab-key     :historical-data
   :tab-str-key "historical-data"
   :tab-label   (loc/tr :historical-data)
   :tab-icon    :fa-history})

(def tab-forecast-data
  {:tab-key     :forecast-data
   :tab-str-key "forecast-data"
   :tab-label   (loc/tr :forecast-data)
   :tab-icon    :fa-calendar})

(def tab-metrics
  {:tab-key     :metrics-selection
   :tab-str-key "metrics-selection"
   :tab-label   (loc/tr :metrics-selection)
   :tab-icon    :fa-thermometer-full})

(def tabs
  [tab-historical-data
   tab-forecast-data
   tab-metrics
   {:tab-key     :mandatoriness
    :disabled?   true
    :tab-str-key "mandatoriness"
    :tab-label   (loc/tr :mandatoriness)}
   {:tab-key     :quality
    :disabled?   true
    :tab-str-key "quality"
    :tab-label   (loc/tr :quality)}
   {:tab-key     :preview
    :tab-str-key "preview"
    :tab-label   (loc/tr :preview)}])


(def root-path [::state])

(def selected-tab-path [:selected-tab])
(defn selected-tab-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path selected-tab-path))

(defn selected-tab-path-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (selected-tab-ctx-path ctx-path)))

(def selected-questions-path [:selected-questions])
(defn selected-questions-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path selected-questions-path))
(defn selected-questions-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (selected-questions-ctx-path ctx-path)))

(def highlight-row-index-path [:highlight-row])
(defn highlight-row-index-path-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path highlight-row-index-path))
(defn highlight-row-index-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (highlight-row-index-path-ctx-path ctx-path)))

(def preview-today-path [:preview-today])
(defn preview-today-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path preview-today-path))
(defn preview-today-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (preview-today-ctx-path ctx-path)))

(def preview-period-type-path [:preview-period-type])
(defn preview-period-type-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path preview-period-type-path))
(defn preview-period-type-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (preview-period-type-ctx-path ctx-path)))

(def preview-period-value-path [:preview-period-value])
(defn preview-period-value-ctx-path
  [ctx-path]
  (uu/vec-cat ctx-path preview-period-value-path))
(defn preview-period-value-full-path
  [ctx-path]
  (uu/vec-cat root-path
              (preview-period-value-ctx-path ctx-path)))

(defn init-preview
  "Stores the day the preview was opened, from which the default period is
  resolved, so subscriptions never read the clock."
  [db {:keys [ctx-path today-utc-midnight-ms]}]
  (assoc-in db (preview-today-full-path ctx-path) today-utc-midnight-ms))

(defn set-preview-period-type
  "A period picked for another type is meaningless, so it is cleared and the
  default period of the new type applies."
  [db {:keys [ctx-path period-type]}]
  (-> db
      (assoc-in (preview-period-type-full-path ctx-path) period-type)
      (potpuri/dissoc-in (preview-period-value-full-path ctx-path))))

(defn set-preview-period-value
  [db {:keys [ctx-path period-value]}]
  (assoc-in db (preview-period-value-full-path ctx-path) period-value))

(defn preview-period-type-options
  []
  (->> survey-reference-periods/reference-periods
       (mapv (fn [period-type]
               {:value period-type
                :label (loc/tr period-type)}))))

(defn preview-period
  "Period type and concrete period of the preview. Without a pick they default
  the way sending a survey does: the template's reference period type (year
  when unset) and its last complete period."
  [{:keys [period-type period-value template-period-type today-ms]}]
  (let [resolved-type (or period-type
                          template-period-type
                          survey-reference-periods/YEAR)
        options (survey-reference-periods/period-options resolved-type)]
    {:period-type resolved-type
     :options     options
     :selected    (or (cu/find-first-by :value period-value options)
                      (survey-reference-periods/last-complete-period options today-ms))}))

(defn preview-table
  "Rows and period columns of the preview. History and forecast are treated as
  off until an option is picked, because the column fns have no default case."
  [{:keys [content history forecast] :as block} reference-period]
  {:rows    (->> content
                 (filter :localized-label)
                 (mapv (fn [{:keys [id localized-label]}]
                         {:id    id
                          :label localized-label})))
   :columns (-> block
                (update :history-in-use? (fn [in-use?]
                                           (boolean (and in-use? history))))
                (update :forecast-in-use? (fn [in-use?]
                                            (boolean (and in-use? forecast))))
                (assoc :reference-period reference-period)
                (timeseries/table-columns))})

(defn set-selected-tab
  [db {:keys [ctx-path new-tab-str] :as ctx}]
  {:db (-> db
           (assoc-in (selected-tab-path-full-path ctx-path)
                     new-tab-str))})

(defn on-drag-move
  [db {:keys [ctx-path over-index]}]
  (assoc-in db (highlight-row-index-full-path ctx-path) over-index))

(defn on-row-drag-end
  [db {:keys [ctx-path]}]
  (potpuri/dissoc-in db (highlight-row-index-full-path ctx-path)))

(defn set-selected-question-ids
  [db {:keys [ctx-path ids]}]
  (assoc-in db (selected-questions-full-path ctx-path) ids))

(defn remove-selected-question-dis
  [db {:keys [ctx-path ids]}]
  (-> db
      (update-in (selected-questions-full-path ctx-path)
                 (fn [old-ids]
                   (->> old-ids
                        (remove (fn [id]
                                  (some #{id} ids)))
                        (set))))))
